export const isDefined = (value) => typeof value !== 'undefined';
export const isNil = (value) => typeof value === 'undefined' || value === null;
export const isNumber = (value) => typeof value === 'number';
export const isString = (value) => typeof value === 'string';
export const isBoolean = (value) => typeof value === 'boolean';
export const isFunction = (value) => typeof value === 'function';
export function isPlainObject(value) {
    if (typeof value !== 'object' || value === null)
        return false;
    let proto = Object.getPrototypeOf(value);
    if (proto === null)
        return true;
    let baseProto = proto;
    while (Object.getPrototypeOf(baseProto) !== null) {
        baseProto = Object.getPrototypeOf(baseProto);
    }
    return proto === baseProto;
}
export const isPrimitive = (value) => {
    const valueType = typeof value;
    return value === null || (valueType !== 'object' && valueType !== 'function');
};
//# sourceMappingURL=type-guard.js.map